
export const TRACKER_PRIMARY = '#6372F2'
export const TRACKER_BENCHMARK1 = '#DE5F46'
export const TRACKER_BENCHMARK2 = '#5BC89A'
export const TRACKER_BENCHMARK3 = '#AD62FA'
export const TRACKER_BENCHMARK4 = '#FFA059'
export const AVERAGE_BENCHMARK = '#FBCB52'

export const WHITE = '#FFFFFF'
export const DARK_GREY = '#808184'

export const CATALOG_NETWORK_PRIMARY = '#61D1EF'
export const CATALOG_NETWORK_DEFAULT1 = '#6372F2'
export const CATALOG_NETWORK_DEFAULT2 = '#5BC89A'

export const GLOBAL_ATTENTION_INDEX_1 = '#ffa059'
export const GLOBAL_ATTENTION_INDEX_2 = '#ff6693'
export const GLOBAL_ATTENTION_INDEX_3 = '#ad62fa'

class SOVColors {
    getSOVColors (network) {
        switch (network) {
            case 'Netflix':
            case 'Media Company: Netflix':
            case 'Streaming':
                return '#DE5F46'
            case 'HBO':
            case 'HBO Max':
            case 'HBO & HBO Max':
            case 'Linear':
            case 'Media Company: Warner Bros. Discovery':
                return '#6372F2'
            case 'Amazon':
            case 'Media Company: Amazon':
                return '#61D1EF'
            case 'Disney+':
            case 'Disney':
            case 'Multichannel':
            case 'Media Company: The Walt Disney Company':
                return '#AD62FA'
            case 'Hulu':
            case 'Media Company: LionsgateStarz':
                return '#5BC89A'
            case 'Apple TV+':
            case 'Media Company: Apple':
                return '#FFA059'
            case 'Peacock':
            case 'Media Company: A&E':
                return '#FF6693'
            case 'Media Company: NBCUniversal':
                return '#FF96FD'
            case 'Paramount+':
            case 'Media Company: ViacomCBS':
                return '#B6E77E'
            case 'Theatrical Release': return '#61D1EF'
            case 'Media Company: AMC': return '#FBCB52'
            case 'Media Company: Fox': return '#5754A4'
            case 'Media Company: Sony Entertainment': return '#FFB6B6'
            case 'Media Company: A24': return '#AA09A7'
            case 'Other':
            case 'Others':
                return '#A7A9AC'
            case 'None': return '#E5E5E5'
        }
    }
    getSOVHoverColors (network, tab) {
        let rootCssGlobalVar = document.querySelector(':root')
        switch (network) {
            case 'Netflix':
            case 'Streaming':
            case 'Media Company: Netflix':
                rootCssGlobalVar.style.setProperty(`--${tab}`, 'rgba(222, 95, 70, 0.2)')
                break
            case 'HBO':
            case 'HBO Max':
            case 'HBO & HBO Max':
                rootCssGlobalVar.style.setProperty(`--${tab}`, 'rgba(99, 114, 242, 0.2)')
                break;
            case 'Amazon':
            case 'Media Company: Amazon':
                rootCssGlobalVar.style.setProperty(`--${tab}`, 'rgba(97, 209, 239, 0.2)')
                break
            case 'Disney+':
            case 'Disney':
            case 'Multichannel':
            case 'Media Company: The Walt Disney Company':
                rootCssGlobalVar.style.setProperty(`--${tab}`, 'rgba(173, 98, 250, 0.2)')
                break
            case 'Hulu':
            case 'Media Company: LionsgateStarz':
                rootCssGlobalVar.style.setProperty(`--${tab}`, 'rgba(91, 200, 154, 0.2)')
                break
            case 'Apple TV+':
            case 'Media Company: Apple':
                rootCssGlobalVar.style.setProperty(`--${tab}`, 'rgba(255, 160, 89, 0.2)')
                break
            case 'Peacock':
            case 'Media Company: A&E':
                rootCssGlobalVar.style.setProperty(`--${tab}`, 'rgba(255, 102, 147, 0.2)')
                break
            case 'Media Company: NBCUniversal':
                rootCssGlobalVar.style.setProperty(`--${tab}`, 'rgba(255, 150, 253, 0.2)')
                break
            case 'Paramount+':
            case 'Media Company: ViacomCBS':
                rootCssGlobalVar.style.setProperty(`--${tab}`, 'rgba(182, 231, 126, 0.2)')
                break
            case 'Linear':
            case 'Media Company: Warner Bros. Discovery':
                rootCssGlobalVar.style.setProperty(`--${tab}`, 'rgba(99, 114, 242, 0.2)')
                break
            case 'Theatrical Release':
                rootCssGlobalVar.style.setProperty(`--${tab}`, 'rgba(97, 209, 239, 0.2)')
                break
            case 'Media Company: AMC':
                rootCssGlobalVar.style.setProperty(`--${tab}`, 'rgba(251, 203, 82, 0.2)')
                break
            case 'Media Company: Fox':
                rootCssGlobalVar.style.setProperty(`--${tab}`, 'rgba(87, 84, 164, 0.2)')
                break
            case 'Media Company: Sony Entertainment':
                rootCssGlobalVar.style.setProperty(`--${tab}`, 'rgba(255, 182, 182, 0.2)')
                break
            case 'Media Company: A24':
                rootCssGlobalVar.style.setProperty(`--${tab}`, 'rgba(170, 9, 167, 0.2)')
                break
            case 'Other':
            case 'Others':
                rootCssGlobalVar.style.setProperty(`--${tab}`, 'rgba(167, 169, 172, 0.2)')
                break
            case 'None':
                rootCssGlobalVar.style.setProperty(`--${tab}`, 'rgba(229, 229, 229, 0.2)')
                break;
        }
    }
}

const instance = new SOVColors()

export default instance